import { createApp } from 'vue'
import "@fontsource/lexend-deca";
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "bootstrap"
import router from "./router.js";

createApp(App).use(router).mount('#app')
